import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const profitabilityRatioAC: CriterionType[] = [
  {
    id: 'PROF-10',
    label: 'Net profit margin (%)',
    shortLabel: 'NetProfitMg',
    unit: '%',
    group: AC_GROUPS.profitabilityRatio,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PROF-20',
    label: 'Operating margin (%)',
    shortLabel: 'OpMg',
    unit: '%',
    group: AC_GROUPS.profitabilityRatio,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PROF-30',
    label: 'EBITD margin (%)',
    shortLabel: 'EBITDMg',
    unit: '%',
    group: AC_GROUPS.profitabilityRatio,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PROF-40',
    label: 'Gross margin (%)',
    shortLabel: 'GrossMg',
    unit: '%',
    group: AC_GROUPS.profitabilityRatio,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PROF-50',
    label: 'Pretax margin (%)',
    shortLabel: 'PretaxMg',
    unit: '%',
    group: AC_GROUPS.profitabilityRatio,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PROF-60',
    label: 'SG&A to sales (%)',
    shortLabel: 'SG&A/Sales',
    unit: '%',
    group: AC_GROUPS.profitabilityRatio,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default profitabilityRatioAC;
